
import { api } from "./index"

const typeApi = {
  getAllTypes: () => api().get('/combo?type=roles,colors,pricetypes,pricelabeltypes,exclusiontypes,difficultylevels,customertargettypes,areas,days,tipologyreseller,priceincreases,languages,sitetypes,priorities,meteoindexes,prenotationtypes,countries,experiencetypes,ivacombos,apikey&manager=true')
}
export default typeApi;